
<transition name="SlideDown">
  <slot />
</transition>
